// extracted by mini-css-extract-plugin
export var borderRadius = "_ey-4";
export var large = "_ey-3";
export var logoContainer = "_ey-0";
export var nameLogo = "_ey-2";
export var small = "_ey-1";